
/* topic filter: chips toggle the cards; /blogs/blog#science etc. opens on that topic */
(function(){
  var chips=[].slice.call(document.querySelectorAll('.bl-chip')),cards=[].slice.call(document.querySelectorAll('.bl-card')),count=document.getElementById('blCount');
  if(!chips.length) return;
  function set(f,push){
    if(!chips.some(function(c){return c.dataset.f===f;})) f='all';
    chips.forEach(function(c){c.setAttribute('aria-pressed',c.dataset.f===f?'true':'false');});
    document.getElementById('blGrid').classList.toggle('filtered',f!=='all');var n=0;cards.forEach(function(c){var on=f==='all'||c.dataset.topic===f;c.hidden=!on;if(on)n++;});
    count.textContent=n+(n===1?' article':' articles');
    if(push){try{history.replaceState(null,'',f==='all'?location.pathname:'#'+f);}catch(e){}}
  }
  chips.forEach(function(c){c.addEventListener('click',function(){set(c.dataset.f,true);});});
  function fromHash(){var h=location.hash.slice(1);if(h)set(h,false);}
  fromHash();window.addEventListener('hashchange',fromHash);
})();
